import { Put, Get, Post, Delete } from './baseHttpService'

const baseUrl = '/configuration-general'

const saveConfiguration = (configurationDto) => {
	return Put(baseUrl, configurationDto)
}

const getAllConfigurations = () => {
	return Get(baseUrl)
}

const getPaymentTicketSettings = () => {
	return Get(`${baseUrl}/payment-ticket-settings`)
}

const savePaymentTicketSettings = (settings) => {
	return Post(`${baseUrl}/payment-ticket-settings`, settings)
}

const deletePaymentSetting = (paymentTicketSettingsId) => {
	return Delete(`${baseUrl}/payment-ticket-settings/${paymentTicketSettingsId}`)
}

export {
	saveConfiguration,
	getAllConfigurations,
	getPaymentTicketSettings,
	savePaymentTicketSettings,
	deletePaymentSetting
}
